import { Component, OnInit, TemplateRef } from '@angular/core';
import { AuthStateService } from 'libs/core/src/lib/state/auth.state.service';
import { TranslationService } from 'libs/core/src/lib/service/translation.service';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { UserStatusComponent } from 'libs/shared/src/lib/component/user/user-status/status.component';
import { environment } from 'apps/cinema1/src/environments/environment';
import { SocialAuthService } from 'libs/core/src/lib/module/auth/public-api';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { Router } from '@angular/router';
import { NavigationService } from 'libs/core/src/lib/service/navigation/navigation.service';

@Component({ standalone: false, selector: 'app-user-status', templateUrl: './status.component.html' })
export class CustomUserStatusComponent extends UserStatusComponent implements OnInit {
  public displayLoginPanel = false;
  public modalRef: BsModalRef;

  constructor(
    protected authStateService: AuthStateService,
    protected socialAuthService: SocialAuthService,
    protected translationService: TranslationService,
    protected orderStateService: OrderStateService,
    protected modalService: BsModalService,
    protected loaderService: LoaderService,
    protected navigationService: NavigationService
  ) {
    super(environment, authStateService, socialAuthService, translationService, orderStateService, loaderService, navigationService);
    this.logoutRedirectPage = environment.backUrl;
  }

  ngOnInit(): void {
    this.authStateService.state$.subscribe((authState) => {
      if (authState?.token) {
        this.modalService.hide();
      }
    });
  }

  public showLoginPopup(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'login-modal' });
  }
}
